import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Label } from '../ui/label';
import { Badge } from '../ui/badge';
import { Eye } from 'lucide-react';
import { fmtDate as fmtDateTz } from '../../lib/datetime';

const formatCurrency = (amount, currency = 'ARS') =>
  new Intl.NumberFormat('es-AR', { style: 'currency', currency, minimumFractionDigits: 2 }).format(amount);
const formatDate = (dateStr) => (dateStr ? fmtDateTz(dateStr) : '-');

const MOVEMENT_TYPE_LABELS = {
  collection: 'Cobranza',
  payment_order: 'Orden de Pago',
  adjustment: 'Ajuste',
  transfer_out: 'Transf. Salida',
  transfer_in: 'Transf. Entrada',
  check_deposit: 'Depósito Cheque',
  check_return: 'Cheque Rechazado',
  reconciliation_adjustment: 'Ajuste Conciliación',
  cash_count_adjustment: 'Ajuste Arqueo',
};

export function MovementDetailDialog({ open, onOpenChange, movement }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Eye className="w-5 h-5" />
            Detalle del Movimiento
          </DialogTitle>
        </DialogHeader>
        {movement && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Label className="text-xs text-muted-foreground">Fecha</Label>
                <p className="font-medium">{formatDate(movement.created_at)}</p>
              </div>
              <div>
                <Label className="text-xs text-muted-foreground">Tipo</Label>
                <p>
                  <Badge variant="outline">
                    {MOVEMENT_TYPE_LABELS[movement.movement_type] || movement.movement_type}
                  </Badge>
                </p>
              </div>
              <div>
                <Label className="text-xs text-muted-foreground">Caja/Banco</Label>
                <p className="font-medium">{movement.cash_bank_name}</p>
              </div>
              <div>
                <Label className="text-xs text-muted-foreground">Referencia</Label>
                <p className="font-mono">{movement.reference_number || '-'}</p>
              </div>
              <div className="col-span-2">
                <Label className="text-xs text-muted-foreground">Concepto</Label>
                <p className="font-medium">{movement.concept_name || '-'}</p>
              </div>
              <div className="col-span-2">
                <Label className="text-xs text-muted-foreground">Descripción</Label>
                <p>{movement.description || '-'}</p>
              </div>
              <div>
                <Label className="text-xs text-muted-foreground">Usuario</Label>
                <p className="font-medium">{movement.created_by_name || '-'}</p>
              </div>
            </div>
            {movement.deleted_at && (
              <div className="rounded-md border border-rose-300 bg-rose-50 dark:bg-rose-950/30 p-3 text-xs text-rose-900 dark:text-rose-200" data-testid="movement-deleted-notice">
                <b>Movimiento ELIMINADO.</b> No suma a ningún saldo ni reporte.
                {movement.deleted_by_name && <span className="block mt-0.5">Eliminado por {movement.deleted_by_name}.</span>}
                {movement.deletion_reason && <span className="block mt-0.5">Motivo: {movement.deletion_reason}</span>}
              </div>
            )}
            <div className={`grid ${movement.deleted_at ? 'grid-cols-2' : 'grid-cols-3'} gap-3 pt-3 border-t`}>
              <div className="text-center">
                <Label className="text-xs text-muted-foreground">Debe</Label>
                <p className="text-lg font-bold text-green-600">
                  {movement.debit > 0 ? formatCurrency(movement.debit) : '-'}
                </p>
              </div>
              <div className="text-center">
                <Label className="text-xs text-muted-foreground">Haber</Label>
                <p className="text-lg font-bold text-red-600">
                  {movement.credit > 0 ? formatCurrency(movement.credit) : '-'}
                </p>
              </div>
              {!movement.deleted_at && movement.balance_after !== null && movement.balance_after !== undefined && (
                <div className="text-center">
                  <Label className="text-xs text-muted-foreground">Saldo</Label>
                  <p className={`text-lg font-bold ${movement.balance_after >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                    {formatCurrency(movement.balance_after)}
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
